// email-sms.component.ts - Fixed version with proper lead navigation handling
import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, Optional, ViewChild, input, effect, OnDestroy, AfterViewInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { firstValueFrom, Subject, debounceTime, takeUntil, switchMap, of, Subscription } from 'rxjs';
import { MaterialModule } from 'src/app/material.module';
import { messageService } from 'src/app/services/message-service';
import { userDataService } from 'src/app/services/userDataService';
import { EmailComponent } from 'src/app/shared/email/email.component';
import { ChatItemComponent } from './chat-item/chat-item.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TruncatePipe } from 'src/app/pipe/truncate.pipe';
import { DialogComponent } from 'src/app/shared/dialog/confirm.dialog';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SmsComponent } from 'src/app/shared/sms/sms.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { FileValidationService } from 'src/app/shared/helper/mimetype-allowed';
import { NotificationsService } from 'src/app/services/notifications/notifications.service';
import { SignatureComponent } from './signature/signature.component';
import { userServices } from 'src/app/services/users.service';
import { CommunicationService } from '../../signal-lead.serice';
import { AttachSectionComponent } from 'src/app/shared/group-message/attach-section/attach-section.component';
import { EmailFormatComponent } from 'src/app/shared/group-message/email-format/email-format.component';
import { DisplayFileComponent } from 'src/app/shared/display-file/display-file.component';
import { tabsComunicationService } from '../../signal-tabs-communication';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DraftStorageService, DraftData } from './draft-storage.service';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { BottomSheetOverviewExampleSheet } from './bottom-sheet/activity-bottom-sheet.component';
import { ActivityLeadService } from 'src/app/services/lead-activity.servise';
import { SocketService } from 'src/app/services/socket.service';
import { TimeProposalModalComponent } from 'src/app/activities/meeting-scheduler/time-proposal-modal/time-proposal-modal.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { leadServices } from 'src/app/services/leads.service';
import { SmsProviderService } from 'src/app/services/sms-provider.service';

export enum emailType {
  systemMail = 'System mail',
  gmail = 'gmail'
}

@Component({
  selector: 'app-email-sms',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    EmailComponent,
    MaterialModule,
    ChatItemComponent,
    TablerIconsModule,
    MatTooltipModule,
    TruncatePipe,
    MatSlideToggleModule,
    FormsModule,
    SmsComponent,
    AttachSectionComponent,
    EmailFormatComponent,
    DisplayFileComponent,
    MatBottomSheetModule,
    MatButtonModule
  ],
  templateUrl: './email-sms.component.html',
  styleUrl: './email-sms.component.scss',
})
export class EmailSmsComponent implements OnInit, OnDestroy, AfterViewInit {
  data = input<any>();
  params = input<any>();
  lead = input<any>();
  createEmail: boolean = false;
  emailForm: FormGroup;
  messages: any;
  currentLead: any;
  isEmailSync: boolean = false
  total: number = 0;
  paramsChild: any;
  showLoad: boolean = true;
  currentUser: any;
  id: any;
  isModal = input<boolean>(false);
  replySubject: string;
  isExpanded: boolean = false;
  replyEmail: boolean = false;
  SpecificEmail: string;
  leadPreference: boolean = false;
  attachedFiles: any[] = [];
  staticFiles: any[] = [];
  isSms = false;
  fullNameCurrentUser: string;
  imageExpand = false;
  showAudioRecorder: boolean = false;
  activeComponent: boolean = false;
  signatures = ''// Replace with your data source
  showGmailBanner: boolean = false
  rcProvider: string | null = null;
  rcConnected: boolean = false;
  maxFilePieces: number = environment.client_max_file_pieces || 5;
  domainCompany:string;

  private destroy$ = new Subject<void>();
  private draftId: number | null = null;
  private isLoadingDraft = false;
  private skipAutoSave = false;
  private draftSaveSubject$ = new Subject<void>();
  private isViewInitialized = false;
  private previousLeadId: any = null;
  private require_activity_after_message: boolean = false


  @ViewChild('video', { static: true })
  videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas', { static: true })
  canvasElement!: ElementRef<HTMLCanvasElement>;
  recivedTabs = this.tabsComunicationService.data

  photo: string | null = null;
  videoStream!: MediaStream;
  hasEmailToReply: boolean
  validateFiles = new FormControl<boolean>(true);
  isSendingEmail: boolean = false;
  private _bottomSheet = inject(MatBottomSheet);
  private socketSubscriptions: Subscription[] = [];
  hasUnseenReply: boolean = false;


  constructor(
    private fb: FormBuilder,
    private userDataService: userDataService,
    private messageService: messageService,
    private router: Router,
    private dialog: MatDialog,
    private checkMimtype: FileValidationService,
    private notification: NotificationsService,
    private userService: userServices,
    private CommunicationService: CommunicationService,
    private tabsComunicationService: tabsComunicationService,
    private snackBar: MatSnackBar,
    private draftStorageService: DraftStorageService,
    private activityLeadService: ActivityLeadService,
    private socketService: SocketService,
    private leadsService: leadServices,
    private smsProviderService: SmsProviderService,
    @Optional() private leadModalRef: MatDialogRef<any>,
  ) {
    this.emailForm = this.fb.group({
      from: [''],
      to: [''],
      cc: [''],
      bcc: [''],
      subject: [''],
      lead_id: [],
      content: ['', Validators.required],
      isSms: [false],
      fromPhoneNumber: [''],
      toPhoneNumber: [''],
      stop_messages: ['']
    });

    effect(() => {
      if (!this.currentUser) {
        return;
      }
    
      const newLead = this.lead();
      const newData = this.data();  // ADD: Watch for data changes
    
      this.currentLead = newLead;

      if (newLead) {
        this.hasUnseenReply = !!newLead.has_unseen_reply;
      }
    
      // Check if lead has actually changed
      if (newLead && newLead.id !== this.previousLeadId) {
        this.previousLeadId = newLead.id;
    
        // Reset component state when lead changes
        this.resetComponentState();
    
        // Update lead-specific data
        this.updateCurrentLead();
    
        // Re-initialize component for new lead
        this.initializeForNewLead();
      } else {
        this.updateImportantRows();
      }
    
      // ADD: Update messages when data input changes (new lead's data loaded)
      if (newData?.data && Array.isArray(newData.data)) {
        this.messages = newData.data;
        this.total = newData.total || 0;
        this.paramsChild = this.params();
        
        // Update showLoad based on new data
        if (+this.paramsChild.pageIndex * +this.paramsChild.pageSize >= this.total) {
          this.showLoad = false;
        } else {
          this.showLoad = true;
        }
      }
    
      const newTabsData:any = this.recivedTabs();
      if (newTabsData?.obj?.data?.message) {
        this.handleNewTabsData(newTabsData);
      }
    
      this.setDefaultCommunicationType();
    });
  }

  loadRcConnectionStatus(): void {
    this.smsProviderService.getMyRcNumber().subscribe({
      next: (res) => {
        this.rcProvider = res?.provider ?? null;
        this.rcConnected = !!res?.number?.rc_connected && !res?.number?.rc_token_expired;
      },
      error: () => {
        this.rcProvider = null;
        this.rcConnected = false;
      },
    });
  }

  goToConnectRc(): void {
    this.leadModalRef?.close();
    this.router.navigate(['/settings/profile'], { queryParams: { tab: 'ringcentral' } });
  }

  handleNewTabsData(data) {
    const message = data?.obj?.data?.message;
    if (!message) return;
  
    // Only add message if it belongs to current lead
    if (Number(message.lead_id) !== Number(this.currentLead?.id)) {
      return;
    }
  
    // Check for duplicate
    if (this.messages?.some(x => x.id === message.id)) {
      return;
    }
  
    // Add to beginning
    this.messages = [message, ...(this.messages || [])];
  }

  async ngOnInit() {
    this.currentUser = await this.userDataService.getUserData();
    this.paramsChild = this.params();
    this.messages = this.data().data;
    this.setDefaultCommunicationType();
    this.total = this.data().total;
    this.currentLead = this.lead();

    // Set initial previous lead id
    this.previousLeadId = this.currentLead?.id;

    if (this.currentLead?.user?.name || this.currentLead?.user?.lastName) {
      this.fullNameCurrentUser =
        `${this.currentLead.user.name || ''} ${this.currentLead.user.lastName || ''}`.trim();
    } else {
      this.fullNameCurrentUser = 'No Name Available';
    }

    this.isSms = this.currentLead.preferred_contact_method?.toLowerCase() === 'sms';

    if (
      +this.paramsChild.pageIndex * +this.paramsChild.pageSize >=
      this.total
    ) {
      this.showLoad = false;
    }

    if (this.currentUser) {
      this.currentUser.signature ? this.signatures = this.currentUser.signature : this.signatures = '';
      this.isEmailSync = !!this.currentUser.GoogleTokens.find(x => x.service === 'GMAIL');
      this.require_activity_after_message = this.currentUser?.Company?.require_activity_after_message
      this.domainCompany = this.currentUser?.Company?.company_domain
    }

    this.emailForm.get('from').patchValue(this.isEmailSync ? this.currentUser.gmail_integration : this.currentUser.email_company)
    this.emailForm.get('stop_messages').patchValue(this.currentLead?.stop_messages)

    if (this.currentLead) {
      this.emailForm.patchValue({ lead_id: this.currentLead?.id })
    }

    this.showGmailBanner = localStorage.getItem('showGmailBanner') ? JSON.parse(localStorage.getItem('showGmailBanner')) : true

    this.loadRcConnectionStatus();

    this.checkIfEmailExist(false)

    // Set up auto-save for drafts
    this.setupAutoSave();

    // Check for drafts and open editor if found
    if (this.currentLead?.id && this.currentUser?.id) {  // Add check for currentUser.id
      const draftType = this.isSms ? 'sms' : 'email';
      this.draftStorageService.getDraft(
        Number(this.currentLead.id), 
        draftType,
        Number(this.currentUser.id)  // Pass userId
      ).then(draft => {
        if (draft) {
          // For email, only check if content or subject exists
          const hasContent = draftType === 'email'
            ? (draft.content || draft.subject)
            : (draft.content || draft.attachedFiles?.length > 0 || draft.staticFiles?.length > 0);
  
          if (hasContent) {
            this.loadDraftAsync().then(() => {
              setTimeout(() => {
                this.expandEditor();
              }, 100);
            });
          }
        }
      });
    }

    this.setupSocketListeners();
  }

  ngAfterViewInit() {
    this.isViewInitialized = true;
  }

  ngOnDestroy() {
    this.socketSubscriptions.forEach(sub => sub.unsubscribe());

    this.destroy$.next();
    this.destroy$.complete();

    // Cleanup all blob URLs
    this.attachedFiles.forEach(file => {
      if (file.url && file.url.startsWith('blob:')) {
        URL.revokeObjectURL(file.url);
      }
    });
  }

  private setupSocketListeners(): void {
    // Listen for message status updates
    const messageStatusSub = this.socketService.messageStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((statusUpdate) => {
        this.handleMessageStatusUpdate(statusUpdate);
      });
  
    // Listen for new messages (direct socket event)
    const newMessageSub = this.socketService.getNewMessages()
      .pipe(takeUntil(this.destroy$))
      .subscribe((newMessage) => {
        this.handleNewMessage(newMessage);
      });
  
    // Listen for inbox messages (from notification flow)
    // This is the primary listener for incoming messages from leads
    const inboxMessageSub = this.socketService.getInboxMessages()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.handleInboxMessage(data);
      });
  
    this.socketSubscriptions.push(messageStatusSub, newMessageSub, inboxMessageSub);
  }

  private resetComponentState() {
    // Clear form state
    this.createEmail = false;
    this.replyEmail = false;
    this.isExpanded = false;
    this.SpecificEmail = '';
    this.replySubject = '';
    this.attachedFiles = [];
    this.staticFiles = [];
    this.draftId = null;
    this.hasEmailToReply = false;

    // Clear any pending auto-saves
    this.skipAutoSave = true;
    this.draftSaveSubject$.next();

    // Reset form to defaults
    this.setEmailFormDefaults(this.isSms);

    setTimeout(() => {
      this.skipAutoSave = false;
    }, 100);
  }

  private initializeForNewLead() {
    // Update full name for new lead
    if (this.currentLead?.user?.name || this.currentLead?.user?.lastName) {
      this.fullNameCurrentUser =
        `${this.currentLead.user.name || ''} ${this.currentLead.user.lastName || ''}`.trim();
    } else {
      this.fullNameCurrentUser = 'No Name Available';
    }

    // Update SMS preference
    this.isSms = this.currentLead.preferred_contact_method?.toLowerCase() === 'sms';

    // Update form with new lead data
    if (this.currentLead) {
      this.emailForm.patchValue({
        lead_id: this.currentLead.id,
        stop_messages: this.currentLead.stop_messages
      });
    }

    // Check if email exists for new lead
    this.checkIfEmailExist(false);

    // Check for drafts for the new lead
    if (this.currentLead?.id && this.isViewInitialized && this.currentUser?.id) {  // Add check for currentUser.id
      const draftType = this.isSms ? 'sms' : 'email';
      this.draftStorageService.getDraft(
        Number(this.currentLead.id), 
        draftType,
        Number(this.currentUser.id)  // Pass userId
      ).then(draft => {
        if (draft) {
          const hasContent = draftType === 'email'
            ? (draft.content || draft.subject)
            : (draft.content || draft.attachedFiles?.length > 0 || draft.staticFiles?.length > 0);
  
          if (hasContent) {
            this.loadDraftAsync().then(() => {
              setTimeout(() => {
                this.expandEditor();
              }, 100);
            });
          }
        }
      });
    }
  }

  private setupAutoSave() {
    // Debounce save operations
    this.draftSaveSubject$
      .pipe(
        debounceTime(1000),
        switchMap(() => {
          if ((this.createEmail || this.replyEmail) && !this.skipAutoSave && !this.isLoadingDraft) {
            return this.saveDraftAsync();
          }
          return of(null);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();

    // Auto-save drafts when form changes
    this.emailForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if ((this.createEmail || this.replyEmail) && !this.skipAutoSave && !this.isLoadingDraft) {
          this.draftSaveSubject$.next();
        }
      });
  }

  private async saveDraftAsync(): Promise<number | null> {
    if (!this.currentLead?.id || !this.currentUser?.id) {  // Check for currentUser.id
      return null;
    }
  
    const currentLeadId = this.emailForm.get('lead_id')?.value || this.currentLead.id;
    const currentType = this.isSms ? 'sms' : 'email';
  
    const draft: DraftData = {
      id: this.draftId,
      leadId: Number(currentLeadId),
      userId: Number(this.currentUser.id),  // Add userId from currentUser
      type: currentType,
      from: this.emailForm.get('from')?.value || '',
      to: this.emailForm.get('to')?.value || '',
      cc: this.emailForm.get('cc')?.value || '',
      bcc: this.emailForm.get('bcc')?.value || '',
      subject: this.emailForm.get('subject')?.value || '',
      content: this.emailForm.get('content')?.value || '',
      fromPhoneNumber: this.emailForm.get('fromPhoneNumber')?.value || '',
      toPhoneNumber: this.emailForm.get('toPhoneNumber')?.value || '',
      attachedFiles: this.attachedFiles,
      staticFiles: this.staticFiles,
      replyEmail: this.replyEmail,
      specificEmail: this.SpecificEmail,
      replySubject: this.replySubject,
      createEmail: this.createEmail,
      timestamp: Date.now()
    };
  
    try {
      // Clear any existing draft ID if type has changed
      if (this.draftId) {
        const existingDraft = await this.draftStorageService.getDraftById(this.draftId);
        if (existingDraft && existingDraft.type !== currentType) {
          this.draftId = null; // Force create new draft for new type
        }
      }
  
      // Pass userId to saveDraft
      this.draftId = await this.draftStorageService.saveDraft(draft, this.currentUser.id);
      return this.draftId;
    } catch (error) {
      console.error('[DRAFT] Failed to save draft:', error);
      return null;
    }
  }

  private saveDraft(): void {
    this.draftSaveSubject$.next();
  }

  private async loadDraftNonBlocking(): Promise<void> {
    if (!this.currentLead?.id || !this.isViewInitialized) {
      return;
    }

    // Don't block the UI - load draft asynchronously
    this.loadDraftAsync().catch(error => {
      console.error('[DRAFT] Failed to load draft:', error);
    });
  }

  private async loadDraftAsync(): Promise<void> {
    if (!this.currentLead?.id || !this.currentUser?.id) {  // Check for currentUser.id
      return;
    }
  
    this.isLoadingDraft = true;
  
    try {
      const draftType = this.isSms ? 'sms' : 'email';
  
      // Pass userId to getDraft
      const draft = await this.draftStorageService.getDraft(
        Number(this.currentLead.id),
        draftType,
        Number(this.currentUser.id)
      );
  
      if (draft && this.isViewInitialized) {
        this.draftId = draft.id || null;
        this.skipAutoSave = true;
  
        // Clear existing attachments before loading new ones
        this.attachedFiles = [];
        this.staticFiles = [];
  
        if (draft.type === 'email') {
          // For email drafts
          this.emailForm.patchValue({
            content: draft.content || '',
            subject: draft.subject || '',
            isSms: false,
            lead_id: this.currentLead.id
          });
  
          // Load email-specific attachments
          if (draft.type === draftType) {
            this.attachedFiles = draft.attachedFiles || [];
            this.staticFiles = draft.staticFiles || [];
          }
        } else {
          // For SMS drafts
          this.replyEmail = draft.replyEmail || false;
          this.SpecificEmail = draft.specificEmail || '';
          this.replySubject = draft.replySubject || '';
          this.createEmail = draft.createEmail || false;
  
          this.emailForm.patchValue({
            from: draft.from,
            to: draft.to,
            cc: draft.cc,
            bcc: draft.bcc,
            subject: draft.subject,
            content: draft.content || '',
            fromPhoneNumber: draft.fromPhoneNumber,
            toPhoneNumber: draft.toPhoneNumber,
            isSms: true,
            lead_id: this.currentLead.id
          });
  
          // Load SMS-specific attachments
          if (draft.type === draftType) {
            this.attachedFiles = draft.attachedFiles || [];
            this.staticFiles = draft.staticFiles || [];
          }
        }
  
        // Force update the content control
        const contentControl = this.emailForm.get('content');
        if (contentControl && draft.content) {
          contentControl.setValue(draft.content);
          contentControl.updateValueAndValidity();
        }
  
        setTimeout(() => {
          this.skipAutoSave = false;
        }, 100);
      } else {
        // No draft found - clear attachments
        this.attachedFiles = [];
        this.staticFiles = [];
      }
    } catch (error) {
      console.error('[DRAFT] Failed to load draft:', error);
      this.attachedFiles = [];
      this.staticFiles = [];
    } finally {
      this.isLoadingDraft = false;
    }
  }

  private async clearCurrentDraft() {
    if (this.draftId) {
      try {
        await this.draftStorageService.deleteDraft(this.draftId);
        this.draftId = null;
      } catch (error) {
        console.error('Failed to clear draft:', error);
      }
    } else if (this.currentLead?.id && this.currentUser?.id) {  // Check for currentUser.id
      try {
        await this.draftStorageService.deleteDraftByLeadAndType(
          Number(this.currentLead.id),
          this.isSms ? 'sms' : 'email',
          Number(this.currentUser.id)  // Pass userId
        );
      } catch (error) {
        console.error('Failed to clear draft by lead and type:', error);
      }
    }
  }

  updateCurrentLead() {
    this.setEmailFormDefaults(this.isSms);
  }

  connectEmail() {
    if (!this.isEmailSync) {
      this.router.navigate(['/settings/profile'], { queryParams: { tab: 2 } });
      this.CommunicationService.sendOneTimeSignal({
        type: 'close-email-modal',
        obj: {}
      });
    }
  }

  async loadMore() {
    this.paramsChild.pageIndex++;
    if (
      +this.paramsChild.pageIndex * +this.paramsChild.pageSize >=
      this.total
    ) {
      this.showLoad = false;
    }
    const response = await firstValueFrom(
      this.messageService.get(this.paramsChild),
    );
    this.messages.push(...response.data);
  }

  updateImportantRows() {
    this.emailForm.patchValue({ stop_messages: this.currentLead?.stop_messages })
  }

  setEmailFormDefaults(isSms: boolean) {
    this.skipAutoSave = true;

    const emailDefaults = {
      isSms,
      from: isSms ? '' : this.isEmailSync ? this.currentUser.gmail_integration : this.currentUser.email_company,
      to: isSms ? '' : this.currentLead.email,
      toPhoneNumber: isSms
        ? this.currentLead.prefix + this.currentLead.phoneNumber
        : '',
      fromPhoneNumber: isSms ? this.currentUser?.Company?.phoneNumber : '',
      cc: '',
      subject: '',
      bcc: '',
      content: '',
      stop_messages: this.currentLead?.stop_messages,
      lead_id: this.currentLead?.id // Always ensure lead_id is set
    };

    this.emailForm.patchValue(emailDefaults);

    setTimeout(() => {
      this.skipAutoSave = false;
    }, 100);
  }

  async selectCommunicationType(type: 'email' | 'sms') {
    const previousType = this.isSms ? 'sms' : 'email';
    const newType = type;
  
    // Save current draft before switching
    if (previousType !== newType && (this.createEmail || this.replyEmail)) {
      await this.saveDraftAsync(); // Make it async and wait
    }
  
    // Clear current attachments BEFORE switching type
    this.attachedFiles = [];
    this.staticFiles = [];
    
    this.isSms = type === 'sms';
    this.setEmailFormDefaults(this.isSms);
  
    // Clear the staticFiles properly
    this.staticFiles = [];
  
    if (!this.replyEmail && !this.createEmail && this.currentUser?.id) {  // Check for currentUser.id
      // Load draft for the new type
      const draft = await this.draftStorageService.getDraft(
        Number(this.currentLead.id),
        newType,
        Number(this.currentUser.id)
      );
  
  
      if (draft) {
        const hasContent = newType === 'email'
          ? (draft.content || draft.subject)
          : (draft.content || draft.attachedFiles?.length > 0 || draft.staticFiles?.length > 0);
  
        if (hasContent) {
          await this.loadDraftAsync();
          setTimeout(() => {
            this.expandEditor();
          }, 100);
        }
      }
      return;
    }
  
    // Clear form and load draft for the new type
    this.skipAutoSave = true;
    
    // Reset form but preserve the editor state
    const wasExpanded = this.isExpanded;
    this.isExpanded = wasExpanded;
    
    if (this.isSms && this.SpecificEmail) {
      this.SpecificEmail = '';
      this.replySubject = '';
      this.replyEmail = false;
    }
  
    if (this.isSms) {
      this.replyEmail = true;
    } else {
      this.checkIfEmailExist(true);
    }
  
    // Load draft for the new type
    await this.loadDraftAsync();
    
    setTimeout(() => {
      this.skipAutoSave = false;
    }, 100);
  }

  async newFileAttach(event: any) {
    const originalFile = event;

    try {
      // Validate file for business use


      let processedFile = originalFile;

      // Compress images
      if (originalFile.type.startsWith('image/')) {
        // Show loading indicator

        try {
          processedFile = await this.compressImage(originalFile);
        } catch (error) {
          console.error('Compression failed:', error);
          this.snackBar.open(
            'Image optimization failed, using original file',
            'Close',
            { duration: 3000 }
          );
          processedFile = originalFile;
        }
      }

      // ✅ ADD: Generate URL for preview
      const fileWithUrl = Object.assign(processedFile, {
        url: URL.createObjectURL(processedFile)
      });

      // Add to attachments
      this.attachedFiles = [...this.attachedFiles, fileWithUrl];

      // Check SMS file limits
      if (this.isSms && this.attachedFiles.length > this.maxFilePieces) {
        this.snackBar.open(
          `SMS messages are limited to ${this.maxFilePieces} attachments. Please remove some files.`,
          'Close',
          { duration: 5000 }
        );
      }

      // Save draft if needed
      if ((this.createEmail || this.replyEmail) && !this.skipAutoSave) {
        this.saveDraft();
      }

    } catch (error) {
      console.error('File processing error:', error);
      this.snackBar.open(
        'Failed to process file. Please try again.',
        'Close',
        { duration: 3000 }
      );
    }
  }

  manageSelectSignature(event: string) {
    this.signatures = '';
    setTimeout(() => {
      this.signatures = event;
    }, 0);
  }

  manageSignatures() {
    const dialogRef = this.dialog.open(SignatureComponent, {
      width: '40%',
      data: { prevSignature: this.signatures }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        const response: any = await firstValueFrom(this.userService.saveSignature(result))
        if (response) {
          this.currentUser.signature = response.signature
          this.signatures = this.currentUser.signature
          this.userDataService.setUserData(this.currentUser)
          this.manageSelectSignature(response.signature)
        }
      }
    });
  }

  async expandEditor() {
    // Set expanded state
    this.isExpanded = true;

    // Don't reset form if we're already in compose/reply mode
    const alreadyEditing = this.createEmail || this.replyEmail;

    if (!alreadyEditing) {
      // Only set defaults if we're not already editing
      this.setEmailFormDefaults(this.isSms);

      if (this.isSms) {
        this.replyEmail = true;
      } else {
        this.checkIfEmailExist(true);
      }

      // Load draft when expanding editor for the first time
      this.loadDraftNonBlocking();
    }
  }

  async composeEmail() {
    this.setEmailFormDefaults(this.isSms);
    this.createEmail = true;
    this.replyEmail = false;
    this.SpecificEmail = '';
    this.replySubject = '';

    // Load draft when composing new email (non-blocking)
    this.loadDraftNonBlocking();
  }

  replySpecificEmail(event: any) {
    this.emailForm.patchValue({
      from: this.isEmailSync ? this.currentUser.gmail_integration : this.currentUser.email_company,
      to: this.currentLead.email,
      isSms: false,
      toPhoneNumber: '',
      fromPhoneNumber: '',
      cc: '',
      bcc: '',
      content: '',
      lead_id: this.currentLead.id // Use current lead ID
    });
    this.createEmail = false;
    this.isSms = false
    this.SpecificEmail = event.email_id;
    this.replySubject = event.subject
    this.replyEmail = true;
    this.isExpanded = true;  // Ensure editor stays open
  }

  infoChat(event: any): void {
    this.dialog.open(InfoModalComponent, {
      width: '70vw',
      maxHeight: '90vh',
      panelClass: 'scrollable-dialog',
      autoFocus: false,
      data: { chat: event, lead: this.currentLead }
    });
  }

  staticTemplateFiles(event) {
    if (event?.id) {
      this.staticFiles = this.staticFiles?.filter(file => file.id !== event.id);
      if (!this.staticFiles?.length) {
        delete this.staticFiles;
      }
    } else if (event?.length > 0) {
      this.staticFiles = event;
    } else {
      delete this.staticFiles;
    }

    if ((this.createEmail || this.replyEmail) && !this.skipAutoSave) {
      this.saveDraft();
    }
  }

  async sendEmailOrSms() {
    if (this.isSendingEmail) {
      return;
    }

    if (!this.validateFiles.value) {
      const totalFiles = this.attachedFiles?.length + this.staticFiles?.length;

      if (this.isSms && totalFiles > this.maxFilePieces) {
        this.snackBar.open(
          `SMS messages are limited to ${this.maxFilePieces} attachments. Please remove some files.`,
          'Close',
          { duration: 3000 }
        );
      } else {
        this.snackBar.open(
          'Attachments exceed the size limit. Remove files or lower their size.',
          'Close',
          { duration: 3000 }
        );
      }
      return;
    }

    this.isSendingEmail = true;

    const emailData: any = { ...this.emailForm.value };

    // Ensure we're using the current lead ID
    emailData.lead_id = this.currentLead.id;

    const staticFiles = this.staticFiles || [];
    if (!this.emailForm.valid) {
      this.notification.showNonErrorSnackBar('Please enter a message to send.', 2000);
      this.isSendingEmail = false;
      return;
    }

    if (this.emailForm.value.content && this.emailForm.value.content.trim()) {
      emailData.content = replaceBracketValues(this.emailForm.value.content);
    }

    const formData = new FormData();

    const validCommunication = await this.checkIfValid(emailData)

    if (!validCommunication) {
      this.isSendingEmail = false;
      return;
    }

    if (this.currentLead?.stop_messages) {
      await this.callDialog("Warning", "This lead cannot receive messages because one or more assigned representatives have blocked messaging. To enable messaging, go to the Action menu and update the settings.", true);
      this.isSendingEmail = false;
      return
    }

    if (!emailData.isSms) {
      if (this.replyEmail) {
        let reciveEmailId;
        let updatedSubject;

        if (!this.SpecificEmail) {
          const findFirstSubj = this.messages[0]

          reciveEmailId = findFirstSubj.email_id
          updatedSubject = findFirstSubj.subject;
        } else {
          reciveEmailId = this.SpecificEmail;
          updatedSubject = this.replySubject;
        }

        emailData.email_id = reciveEmailId;
        emailData.subject = updatedSubject;
      } else {
        if (!emailData.subject?.trim()) {
          const confirmed = await this.callDialog(
            'No subject!',
            'Are you sure you want to send the email without a subject?'
          );

          if (!confirmed) {
            this.isSendingEmail = false;
            return
          }
        }
      }
    }

    formData.append('data', JSON.stringify(emailData));
    formData.append('staticFile', JSON.stringify(staticFiles))
    this.attachedFiles.forEach((file: File) => {
      formData.append('files', file);
    });

    try {
      // ✅ ADD: Create immediate pending message in UI
      const pendingMessage = {
        id: `pending-${Date.now()}`,
        content: emailData.content,
        isSms: emailData.isSms,
        direction: 'sent',
        lead_id: this.currentLead.id,
        created_at: new Date().toISOString(),
        // Pending message indicators
        temporary_failure: true,
        temporary_message: 'Sending...',
        isError: false,
        delivered: false,
        sent: false,
        status: 'pending',
        // Add attachment count if any
        attachment_count: this.attachedFiles?.length + staticFiles?.length || 0,
        // Add unique identifier for socket updates
        unique_id: `pending-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      };

      // ✅ ADD: Immediately add pending message to UI
      this.messages.unshift(pendingMessage);

      // ✅ CHANGE: Use async endpoint instead of sync
      const response = await firstValueFrom(
        this.messageService.post(formData, { isEmailSync: this.isEmailSync, isGroupMessage: false })
      );


      // ✅ ADD: Handle async response
      if (response) {
        // Message was queued successfully

        // Update the pending message with job info
        const messageIndex = this.messages.findIndex(msg => msg.id === pendingMessage.id);
        if (messageIndex > -1) {
          this.messages[messageIndex] = {
            ...this.messages[messageIndex],
            job_id: response.jobId,
            unique_id: response.uniqueId || this.messages[messageIndex].unique_id
          };
        }
      } else {
        // Fallback for synchronous response (shouldn't happen with async endpoint)
        this.handleSynchronousResponse(response, pendingMessage);
      }

      // ✅ KEEP: Reset form state
      this.resetFormAfterSend();


    } catch (error) {
      // ✅ ADD: Handle error - remove pending message and show error
      const pendingIndex = this.messages.findIndex(msg => msg.id?.toString().startsWith('pending-'));
      if (pendingIndex > -1) {
        this.messages.splice(pendingIndex, 1);
      }

      const message = error?.error?.message || error?.message || 'Server error'
      this.notification.showClientError(message)
    } finally {
      this.isSendingEmail = false;
    }
  }

  // ✅ ADD: Helper method for handling synchronous responses (fallback)
  private handleSynchronousResponse(response: any, pendingMessage: any) {
    // Remove pending message
    const pendingIndex = this.messages.findIndex(msg => msg.id === pendingMessage.id);
    if (pendingIndex > -1) {
      this.messages.splice(pendingIndex, 1);
    }

    // Add real message
    this.messages.unshift(response);
    this.hasEmailToReply = true;
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetOverviewExampleSheet);
  }

  leadActivityModal() {
    const bottomSheetRef = this._bottomSheet.open(BottomSheetOverviewExampleSheet, {
      data: {
        leadId: this.currentLead?.id,
        leadName: this.currentLead?.fullName || this.fullNameCurrentUser
      },
      panelClass: 'activity-reminder-bottom-sheet',
      disableClose: false
    });

    bottomSheetRef.afterDismissed().subscribe(result => {
      if (result?.action === 'create') {
        // Open the existing activity creation dialog
        this.openActivityCreationDialog();
      }
    });
  }

  async openActivityCreationDialog() {
    await this.activityLeadService.openActivityOnlyModal({
      detailed: true,
      hideCalendarProps: true,
      isExternal: true,
      listView: true,
      defaultLead: this.currentLead?.id,
      isModal: true,
    });
  }

  async cancel() {
    await this.clearCurrentDraft();

    this.attachedFiles = [];
    this.staticFiles = [];
    this.createEmail = this.replyEmail = false;
    this.isExpanded = false;  // Close editor on cancel
    this.SpecificEmail = '';
    this.replySubject = '';
    this.setEmailFormDefaults(this.isSms);
  }

  async checkIfValid(emailData: { isSms: boolean }): Promise<boolean> {
    const isSms = emailData.isSms;

    if (isSms) {
      if (!this.currentLead.phoneNumber) {
        await this.callDialog(
          "Warning",
          "This lead has no phone number, you can't send an SMS",
          true
        );
        return false;
      }
      if (this.currentLead.invalid_sms) {
        await this.callDialog(
          "Warning",
          "This lead has an invalid SMS number, you can't send an SMS",
          true
        );
        return false;
      }
    } else {
      if (!this.currentLead.email) {
        await this.callDialog(
          "Warning",
          "This lead has no Email address, you can't send an Email",
          true
        );
        return false;
      }

      if (this.currentLead.invalid_email) {
        await this.callDialog(
          "Warning",
          "This lead has an invalid Email address, you can't send an Email",
          true
        );
        return false;
      }
    }

    return true;
  }


  checkIfEmailExist(openImmediately) {
    let lastMessage = this.messages[0];
  
    if (!lastMessage) {
      if (openImmediately) {
        this.createEmail = true;
        this.replyEmail = false;
      } else {
        this.hasEmailToReply = false;
      }
      return;
    }
  
    const isReceived = lastMessage.direction === 'received';
    
    // Check if email is from our domain (for sent) or can be replied to (for received)
    const emailAddress = isReceived ? lastMessage.to : lastMessage.from;
    const isFromCompanyDomain = emailAddress?.includes(`@${this.domainCompany}`);
  
    const hasEmailTrue =
      lastMessage.isSms === false &&
      !lastMessage.temporary_failure &&
      !lastMessage.isError &&
      (this.isEmailSync 
        ? lastMessage.typeEmail === emailType.gmail 
        : isFromCompanyDomain);
  
    this.replySubject = lastMessage.subject;
  
    if (openImmediately) {
      if (hasEmailTrue) {
        this.replyEmail = true;
        this.createEmail = false;
      } else {
        this.createEmail = true;
        this.replyEmail = false;
      }
    } else {
      this.hasEmailToReply = hasEmailTrue;
    }
  }

  callDialog(header: string, content: string, isInfo = false, type = 'info', buttonName = '') {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        header,
        content,
        isInfo,
        type,
        buttonName
      },
      width: '600px',
    });

    return dialogRef.afterClosed().toPromise();
  }

  close() {
    this.showGmailBanner = false
    localStorage.setItem('showGmailBanner', 'false')
  }


  private handleMessageStatusUpdate(update: {
    jobId?: string;
    status: 'queued' | 'sending' | 'sent' | 'failed';
    uniqueId?: string;
    leadId?: number;
    messageRecord?: any;
    pendingMessage?: any;
    error?: string;
  }): void {

    // Only process updates for current lead
    if (update.leadId && update.leadId !== this.currentLead?.id) {
      return;
    }

    switch (update.status) {
      case 'queued':
        this.handleMessageQueued(update);
        break;

      case 'sending':
        this.handleMessageSending(update);
        break;

      case 'sent':
        this.handleMessageSent(update);
        break;

      case 'failed':
        this.handleMessageFailed(update);
        break;
    }
  }

  private handleMessageQueued(update: any): void {

    // Add pending message if provided by backend
    if (update.pendingMessage) {
      // Insert at the beginning of the messages array
      this.messages.unshift(update.pendingMessage);
    }

    // Show user feedback
    this.snackBar.open('Message queued for sending', '', { duration: 2000 });
  }

  private handleMessageSending(update: any): void {

    // Find and update pending message status
    this.updatePendingMessageInList(update.uniqueId || update.jobId, {
      temporary_message: 'Sending...',
      status: 'sending'
    });
  }

  private handleMessageSent(update: any): void {

    if (update.messageRecord) {
      // Replace pending message with real message
      this.replacePendingWithRealMessage(
        update.jobId || update.uniqueId,
        update.messageRecord
      );
    } else {
      // Fallback: just remove pending and refresh
      this.removePendingMessage(update.uniqueId || update.jobId);
      this.refreshMessages();
    }

    this.snackBar.open('Message sent successfully!', 'Close', { duration: 3000 });
  }

  private handleMessageFailed(update: any): void {

    // Update pending message to show error
    this.updatePendingMessageInList(update.uniqueId || update.jobId, {
      temporary_message: `Failed: ${update.error}`,
      isError: true,
      error_message: update.error,
      status: 'failed'
    });

    // Show retry option
    const snackBarRef = this.snackBar.open(
      `Send failed: ${update.error}`,
      'Retry',
      { duration: 8000 }
    );

    snackBarRef.onAction().subscribe(() => {
      this.retryFailedMessage(update.uniqueId || update.jobId);
    });
  }

  private handleNewMessage(data: any): void {

    // Only add if it's for the current lead
    if (data.leadId === this.currentLead?.id && data.message) {
      // Check if message already exists to avoid duplicates
      const exists = this.messages.some(msg =>
        msg.id === data.message.id ||
        msg.email_db_id === data.message.email_db_id ||
        msg.message_id === data.message.message_id
      );

      if (!exists) {
        this.messages.unshift(data.message);

        // Show notification for received messages
        if (data.message.direction === 'received') {
          this.snackBar.open(
            `New ${data.message.isSms ? 'SMS' : 'email'} received`,
            'View',
            { duration: 5000 }
          );
        }
      }
    }
  }

  private updatePendingMessageInList(identifier: string, updates: any): void {
    if (!identifier) return;

    const messageIndex = this.messages.findIndex(msg =>
      msg.unique_id === identifier ||
      msg.job_id === identifier ||
      msg.id === `pending-${identifier}`
    );

    if (messageIndex > -1) {
      // Update the pending message with new status
      Object.assign(this.messages[messageIndex], updates);
    } else {
      console.warn('⚠️ Pending message not found for update:', identifier);
    }
  }

  private replacePendingWithRealMessage(identifier: string, realMessage: any): void {
    if (!identifier) return;

    const messageIndex = this.messages.findIndex(msg =>
      msg.unique_id === identifier ||
      msg.job_id === identifier ||
      msg.jobId === identifier ||
      msg.id === `pending-${identifier}`
    );

    if (messageIndex > -1) {
      // Replace pending message with real message
      this.messages[messageIndex] = realMessage;
    } else {
      // Fallback: add real message at the beginning
      this.messages.unshift(realMessage);
    }
  }

  private removePendingMessage(identifier: string): void {
    if (!identifier) return;

    const messageIndex = this.messages.findIndex(msg =>
      msg.unique_id === identifier ||
      msg.job_id === identifier ||
      msg.id === `pending-${identifier}`
    );

    if (messageIndex > -1) {
      this.messages.splice(messageIndex, 1);
    }
  }

  private retryFailedMessage(identifier: string): void {
    const messageIndex = this.messages.findIndex(msg =>
      msg.unique_id === identifier ||
      msg.job_id === identifier
    );

    if (messageIndex > -1) {
      const failedMessage = this.messages[messageIndex];

      // Remove failed message
      this.messages.splice(messageIndex, 1);

      // Restore content to form for retry
      this.emailForm.patchValue({
        content: failedMessage.content,
        subject: failedMessage.subject || ''
      });

      // Set the correct message type
      this.isSms = failedMessage.isSms || false;
      this.setEmailFormDefaults(this.isSms);

      // Expand editor for retry
      this.expandEditor();

      this.snackBar.open('Message restored for retry', 'Close', { duration: 2000 });
    }
  }

  private async refreshMessages(): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.messageService.get(this.paramsChild)
      );
      this.messages = response.data;
      this.total = response.total;
    } catch (error) {
      console.error('❌ Failed to refresh messages:', error);
    }
  }

  private resetFormAfterSend(): void {
    // ✅ KEEP: All existing form reset logic
    this.replyEmail = false;
    this.SpecificEmail = '';
    this.replySubject = '';
    this.attachedFiles = [];
    this.staticFiles = [];
    this.hasEmailToReply = true;
    this.setEmailFormDefaults(this.isSms);
    if (!this.replyEmail) this.createEmail = false;
    this.isExpanded = false;

    // ✅ KEEP: Clear drafts
    this.clearCurrentDraft();

    // ✅ KEEP: Signal update to other components
    const obj = { location: 'sms-email', update: true };
    this.CommunicationService.updateData({
      type: 'sms-email',
      obj,
    });

    // ✅ KEEP: Activity modal if required
    if (this.require_activity_after_message) {
      this.leadActivityModal();
    }
  }


  /**
 * Format file size for display
 */
  private formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';

    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  /**
 * Compress image for CRM business use
 */
  private async compressImage(file: File): Promise<File> {
    if (!file.type.startsWith('image/')) {
      return file;
    }


    const COMPRESSION_THRESHOLD = 700 * 1024; // 500KB in bytes
    if (file.size <= COMPRESSION_THRESHOLD) {
      return file;
    }

    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onerror = () => reject(new Error('Failed to load image'));

      img.onload = () => {
        try {
          // CRM-optimized settings
          const maxDimension = this.isSms ? 1024 : 1600; // Good quality for business
          const quality = this.isSms ? 0.75 : 0.85; // Professional quality

          // Calculate new dimensions
          const ratio = Math.min(
            maxDimension / img.width,
            maxDimension / img.height,
            1 // Don't upscale
          );

          canvas.width = img.width * ratio;
          canvas.height = img.height * ratio;

          // Draw image
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert to blob
          canvas.toBlob(
            (blob) => {
              if (blob) {
                const compressedFile = new File([blob], file.name, {
                  type: file.type,
                  lastModified: Date.now()
                });
                resolve(compressedFile);
              } else {
                reject(new Error('Failed to compress image'));
              }
            },
            file.type,
            quality
          );
        } catch (error) {
          reject(error);
        } finally {
          // Clean up
          URL.revokeObjectURL(img.src);
        }
      };

      img.src = URL.createObjectURL(file);
    });
  }

  private setDefaultCommunicationType() {
    // 1️⃣ If messages exist → detect communication type based on last message
    if (this.messages?.length > 0) {
      const last = this.messages[0];
  
      // Last message was SMS
      if (last.isSms === true) {
        this.isSms = true;
        return;
      }
  
      // Last message was EMAIL
      if (last.isSms === false) {
        this.isSms = false;
        return;
      }
    }
  
    // 2️⃣ If no messages → fallback to lead preference
    if (this.currentLead?.preferred_contact_method) {
      this.isSms = this.currentLead.preferred_contact_method.toLowerCase() === 'sms';
      return;
    }
  
    // 3️⃣ Default → EMAIL
    this.isSms = false;
  }

  // In email-sms.component.ts
  // Update the openMeetingScheduler method

  openMeetingScheduler(): void {
    this.expandEditor();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '1200px';
    dialogConfig.height = '80%';
    dialogConfig.panelClass = 'time-proposal-dialog';
    dialogConfig.disableClose = true;

    // Pass the current lead data to the modal
    dialogConfig.data = {
      type: 'specific_times',
      lead: this.currentLead
    };

    const dialogRef = this.dialog.open(TimeProposalModalComponent, dialogConfig);

    // Handle dialog width changes
    dialogRef.afterOpened().subscribe(() => {
      if (dialogRef.componentInstance) {
        dialogRef.componentInstance.showAutoWidth.subscribe((autoWidth: boolean) => {
          const newWidth = autoWidth ? '90%' : 'auto';
          dialogRef.updateSize(newWidth, '80%');
        });
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.meetingId) {
        // Generate meeting link
        const meetingLink = `${environment.uiUrl}/meeting-schedule/${result.meetingId}`;

        if (result.action === 'done') {
          // When "Done" is clicked, just copy the link to clipboard
          navigator.clipboard.writeText(meetingLink).then(() => {
            this.snackBar.open('Meeting link copied to clipboard!', 'Close', {
              duration: 5000
            });
          }).catch(err => {
            console.error('Failed to copy meeting link:', err);
            this.snackBar.open('Failed to copy meeting link. Please copy it manually from the Share tab.', 'Close', {
              duration: 5000
            });
          });
        }
        else if (result.action === 'send') {
          // Handle the "Send as" action
          const messageText = `Here's my calendar link to schedule: ${meetingLink}`;

          if (result.type === 'sms') {
            // For SMS
            this.isSms = true;
            this.setEmailFormDefaults(true); // Ensure SMS form is properly set
            this.replyEmail = true;

            // Insert the message with a slight delay to ensure form is ready
            setTimeout(() => {
              const content = this.emailForm.get('content');
              if (content) {
                content.setValue(messageText);
                content.markAsDirty();
              }
            }, 100);
          } else {
            // For Email - we need to handle it differently
            this.isSms = false;
            this.setEmailFormDefaults(false); // Ensure email form is properly set

            // First cancel any existing compose to reset state
            this.cancel();

            // Then set up new email compose
            setTimeout(() => {
              this.composeEmail();

              // Add another timeout to ensure the form is ready after composeEmail
              setTimeout(() => {
                // Set the subject
                const subjectControl = this.emailForm.get('subject');
                if (subjectControl) {
                  const subjectText = result.subject || `Meeting scheduling link: ${this.currentLead?.fullName || 'Meeting'}`;
                  subjectControl.setValue(subjectText);
                }

                // Set the content
                const content = this.emailForm.get('content');
                if (content) {
                  content.setValue(messageText);
                }
              }, 100);
            }, 100);
          }

          // Show confirmation
          this.snackBar.open(`Meeting link ready to send as ${result.type.toUpperCase()}`, 'Close', {
            duration: 3000
          });
        }
      }
    });
  }

  /**
 * Handle incoming message from notification flow (same stream inbox sidebar uses)
 * This is triggered when a lead sends a message (email or SMS)
 */
private handleInboxMessage(data: any): void {
  const leadId = data.notification?.record_id;
  const message = data.message;
  
  // Only process if it's for the current lead
  if (!leadId || leadId !== this.currentLead?.id) {
    return;
  }

  if (message) {
    // Check if message already exists to prevent duplicates
    const exists = this.messages?.some(msg =>
      msg.id === message.id ||
      msg.email_db_id === message.email_db_id ||
      msg.message_id === message.message_id
    );

    if (!exists) {
      // Add the new message to the beginning of the list
      this.messages = [
        {
          id: message.id,
          content: message.content,
          subject: message.subject || null,
          from: message.from || null,
          to: message.to || null,
          direction: message.direction || 'received',
          isSms: message.isSms,
          isError: false,
          error_message: null,
          created_at: message.created_at || new Date().toISOString(),
          createdBy: message.createdBy || null,
          attachments: message.attachments || [],
          typeEmail: message.typeEmail || null,
          seen: false,
          delivered: true,
          sent: true,
          temporary_failure: false,
          status: 'delivered'
        },
        ...(this.messages || [])
      ];

      this.hasUnseenReply = true;

      // Show notification for received messages
      this.snackBar.open(
        `New ${message.isSms ? 'SMS' : 'email'} received`,
        'View',
        { duration: 5000 }
      );
    }
  }
}

  // Add this method to EmailSmsComponent
  async removeFileFromCache(cacheKey: string) {
    // Remove from cache first
    await this.draftStorageService.removeCachedFile(cacheKey);
    
    // Force save draft after cache removal completes
    // This ensures the draft doesn't retain stale file references
    this.skipAutoSave = true;
    await this.saveDraftAsync();
    this.skipAutoSave = false;
  }


  markAsRead(): void {
    if (!this.currentLead?.id || !this.hasUnseenReply) return;
  
    this.leadsService.markInboxAsSeen(this.currentLead.id).subscribe({
      next: (response) => {
        if (response.success) {
          this.hasUnseenReply = false;
          if (response.newInboxCount !== undefined) {
            this.socketService.setInboxCount(response.newInboxCount);
          }
          // Notify parent to update lead's has_unseen_reply
          this.CommunicationService.updateData({
            type: 'mark-as-read',
            obj: { leadId: this.currentLead.id },
          });
        }
      },
      error: (err) => {
        console.warn('Failed to mark messages as read:', err);
      },
    });
  }
}

function replaceBracketValues(content: string): string {
  const regex = /\[\[(.*?)\]\]/g;
  return content.replace(regex, (_, group) => group);
}